import { useRouter } from 'next/router';
import { Controller, useForm } from 'react-hook-form';
import { LoginFormStyle } from '../../styles/components/login';
import { Button, Checkbox, Input } from '../common/ui';

import { yupResolver } from '@hookform/resolvers/yup';
import { boolean, object, ref, string } from 'yup';
import PasswordInputWithToggle from '../common/ui/PasswordInputWithToggle';
export interface IRegisterFormValues {
  name?: string;
  email?: string;
  password?: string;
  passwordConfirm?: string;
  newsletter?: boolean;
  terms?: boolean;
}

export interface IRegisterFormProps {
  labels?: {
    nameLabel: string;
    emailLabel: string;
    passwordLabel: string;
    confirmPasswordLabel: string;
    newsletterCheckboxLabel: string;
    termsCheckboxLabel: string;
    submitButton: string;
    logInTip: string;
    logInButton: string;
    formSubmitSuccessMessage: string;
    formSubmitErrorMessage: string;
  };
  validation: {
    nameRequiredMessage: string;
    emailNotValidMessage: string;
    emailRequiredMessage: string;
    passwordRequiredMessage: string;
    passwordConfirmationRequiredMessage: string;
    passwordNotMatchMessage: string;
    termsRequiredMessage: string;
  };
  termsLink?: string;
  disabled?: boolean;
  onFormSubmit: (formData: IRegisterFormValues) => void;
}

const RegisterForm = (props: IRegisterFormProps) => {
  const router = useRouter();
  const validationSchema = object().shape({
    name: string().trim().required(props.validation.nameRequiredMessage),
    email: string()
      .email(props.validation.emailNotValidMessage)
      .required(props.validation.emailRequiredMessage),
    password: string().required(props.validation.passwordRequiredMessage),
    passwordConfirm: string()
      .required(props.validation.passwordConfirmationRequiredMessage)
      .oneOf([ref('password'), ''], props.validation.passwordNotMatchMessage),
    newsletter: boolean(),
    terms: boolean().oneOf([true], props.validation.termsRequiredMessage),
  });

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<IRegisterFormValues>({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data: IRegisterFormValues) => {
    props.onFormSubmit(data);
  };

  return (
    <div className={LoginFormStyle.container}>
      <div className={LoginFormStyle.subContainer}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Controller
            name="name"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Input
                name="name"
                type="text"
                id="name"
                label={props.labels?.nameLabel}
                value={value}
                error={errors.name?.message}
                disabled={props.disabled}
                onChange={(e: any) => onChange(e.target.value)}
              />
            )}
          />
          <Controller
            name="email"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Input
                name="email"
                type="email"
                id="email"
                label={props.labels?.emailLabel}
                value={value}
                error={errors.email?.message}
                disabled={props.disabled}
                onChange={(e: any) => {
                  onChange(e.target.value);
                }}
              />
            )}
          />
          <Controller
            name="password"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <PasswordInputWithToggle
                id="password"
                label={props.labels?.passwordLabel}
                error={errors.password?.message}
                name="password"
                disabled={props.disabled}
                onChange={(e: any) => {
                  onChange(e.target.value);
                }}
              />
            )}
          />
          <Controller
            name="passwordConfirm"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <PasswordInputWithToggle
                id="passwordConfirm"
                label={props.labels?.confirmPasswordLabel}
                value={value}
                error={errors.passwordConfirm?.message}
                name="passwordConfirm"
                disabled={props.disabled}
                onChange={(e: any) => {
                  onChange(e.target.value);
                }}
              />
            )}
          />
          <Controller
            name="newsletter"
            control={control}
            defaultValue={false}
            render={({ field: { onChange } }) => (
              <Checkbox
                id="newsletter"
                name="newsletter"
                label={props.labels?.newsletterCheckboxLabel}
                disabled={props.disabled}
                onChange={(e: any) => {
                  onChange(e.target.checked);
                }}
              />
            )}
          />

          <Controller
            name="terms"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <Checkbox
                id="terms"
                label={
                  <span>
                    <a
                      style={{ color: '#307ee1' }}
                      target="_system"
                      href={props.termsLink}>
                      {props.labels?.termsCheckboxLabel}
                    </a>
                  </span>
                }
                error={errors.terms?.message}
                name="terms"
                disabled={props.disabled}
                onChange={(e: any) => {
                  onChange(e.target.checked);
                }}
              />
            )}
          />
          <Button style={{ width: '100%', marginTop: '30px' }} type="submit">
            {props.labels?.submitButton}
          </Button>
          <div className={LoginFormStyle['bottomSection']}>
            {props.labels?.logInTip}
            <Button
              onClick={() => {
                router.push('/account/login');
              }}
              style={{ marginLeft: '5px' }}
              type="button"
              disabled={props.disabled}
              color="minimal">
              {props.labels?.logInButton}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterForm;
